import { Flex, Grid, ListItem } from "@chakra-ui/react";
import * as SingleSchoolRank from "./SingleSchoolRank";

export type Form = SingleSchoolRank.Form;
export type Offer = SingleSchoolRank.Offer;
export type RankedSchool = SingleSchoolRank.RankedSchool & {
  readonly rank: number;
};
export type School = SingleSchoolRank.School;
export type Waitlist = SingleSchoolRank.Waitlist;
interface RankedSchoolListItemProps {
  formTemplateId: uuid;
  acceptedOfferSchoolName: string | undefined;
  form: Form;
  offer: Offer | null;
  formSchoolRank: RankedSchool;
  waitlist: Waitlist | null;
  gradeLabel: string;
  school: School;
  studentName: string;
  rankingEnabled: boolean;
  enrollmentPeriodKey: string | null;
  showWaitlistPosition: boolean;
}

export function RankedSchoolListItem(props: RankedSchoolListItemProps) {
  const { formSchoolRank, rankingEnabled } = props;

  // ListItem cannot have `display="flex"` or bullets won't show up
  return (
    <ListItem ml={rankingEnabled ? 0 : 5}>
      <Flex alignItems="center" gap={2}>
        {rankingEnabled && (
          <Grid
            alignSelf="stretch"
            borderInlineEndColor="gray.400"
            borderInlineEndStyle="solid"
            borderInlineEndWidth="1px"
            flexBasis={6}
            flexGrow={0}
            flexShrink={0}
            placeContent="center"
          >
            {formSchoolRank.rank + 1}
          </Grid>
        )}
        <SingleSchoolRank.SingleSchoolRank {...props} />
      </Flex>
    </ListItem>
  );
}
